// Valitions Errors
export const ERROR_EMAIL = 'Please enter a valid email address.';
export const ERROR_UNSUPPORTED_EMAIL = 'A professional email address is required.';
export const ERROR_REQUIRED = 'Required field.';
export const ERROR_MINLENGTH = 'Minimum 10 characters required';
export const ERROR_CONFIRM_PASS = 'Passwords do not match';
export const ERROR_NUMBER = 'Not a valid number.';
export const ERROR_INVALID_NAME = `Please remove the " or '`;
export const ERROR_NETWORK_CONNECTION = 'ERROR_NETWORK_CONNECTION';
export const ERROR_PASSWORD_CORRECT = 'Current password is incorrect.';
export const ERROR_PASSWORD_NOT_UNIQUE = 'New password cannot be the same as current password';
export const ERROR_PASSWORD_INFO = (
    <>
        Password requirements:
        <ul>
            <li>Minimum length: 10</li>
            <li>Require number</li>
            <li>Require special character</li>
            <li>Require uppercase letter</li>
            <li>Require lowercase letter</li>
            <li>Must not contain username</li>
            <li>Must not contain first name</li>
            <li>Must not contain last name</li>
            <li>Must not be one of your last 10 passwords</li>
        </ul>
    </>
);

export const ERROR_PASSWORD = 'Please enter a valid password.';

export const SUCCESS_RESET_PASSWORD = 'Password changed.';
export const FORGOT_SENT_ACTIVE_CODE = 'Verification code sent. Please check your inbox.';
export const ERROR_CHANGE_PASSWORD = 'Change password failed';

// User Signup
export const SUCCESS_USER_SIGNUP = 'Your account has been created. Please check your email for verification.';
export const ERROR_USER_SIGNUP = 'Sign up failed. Please try again later.';

export const SUCCESS_ACTIVATE_ACCOUNT =
    'Thank you for verifying your email address. You will be redirected to the Sign In page in a few seconds...';
export const SUCCESS_ACTIVATE_ACCOUNT_FEDERATED =
    'Thank you for verifying your email address. You will be redirected to Paytron in a few seconds...';

// Error payment page
export const SUCCESS_DELETE_PAYMENT = 'Payment deleted.';
export const ERROR_DELETE_PAYMENT = 'Payment deletion failed.';

export const SUCCESS_DELETED_PAYMENTS = 'Payments deleted.';
export const PARTIAL_SUCCESS_DELETED_PAYMENTS =
    'Not all payments were successfully deleted, please retry for the unsuccessfully deleted payments.';

// --- End payment page

export const ERROR_INVOICE_FILE_TYPE =
    'The file you’ve uploaded is not compatible with Invoice Autopilot. The supported file types are: JPEG, PNG, and PDF.';
export const ERROR_INVOICE_FILE_MAXIMUM =
    'The file you’ve uploaded is too large for Invoice Autopilot. The maximum file size is 25mb.';
export const ERROR_INVOICE_MANY_FILE =
    'Invoice Autopilot only supports files that contain a single invoice. We’re working on this, but please split the invoice up for now.';

export const ERROR_INVOICE_FILE_TYPE_HEADER = 'Unsupported file type';
export const ERROR_INVOICE_FILE_MAXIMUM_HEADER = 'File too large';
export const ERROR_INVOICE_MANY_FILE_HEADER = 'Too many invoices';

// MFA
export const ERROR_ENABLE_MFA_SMS = 'Enabling SMS authentication failed. Please try again.';
export const ERROR_DISABLE_MFA_SMS = 'Disabling SMS authentication failed. Please try again.';
export const SUCCESS_SEND_CODE_MFA_SMS = 'The code sent successfully. Please check on your phone.';
export const ERROR_SEND_CODE_MFA_SMS = 'The code sent failed. Please try again.';
export const SUCCESS_ENABLE_MFA_SMS = 'Enabled SMS authentication successfully.';
export const SUCCESS_DISABLE_MFA_SMS = 'Disabled SMS authentication successfully.';
export const ERROR_INVALID_CODE_MFA_SMS = 'The code is invalid.';

export const ERROR_ENABLE_MFA_TOTP = 'Enable TOTP Authentication failed. Please try again.';
export const ERROR_DISABLE_MFA_TOTP = 'Disable TOTP Authentication failed. Please try again.';
export const SUCCESS_ENABLE_MFA_TOTP = 'Enabled TOTP Authentication successfully.';
export const SUCCESS_DISABLE_MFA_TOTP = 'Disabled TOTP Authentication successfully.';
export const ERROR_INVALID_CODE_MFA_TOTP = 'The code is invalid.';

export const INSUFFICIENT_INVITE_PERMISSIONS = 'Higher permissions than your own.';
